import { AxiosError } from "axios"

import { VERIFICATION_ERROR, VERIFICATION_ERROR_MAP } from "../../common"

export const getVerificationError = (e: unknown) => {
    const errorText = "Неизвестная ошибка"
    if (e instanceof AxiosError && e.response) {
        const { error } = e.response.data as { error: string }
        if (error in VERIFICATION_ERROR_MAP) {
            return VERIFICATION_ERROR_MAP[error as VERIFICATION_ERROR]
        }
        return errorText
    }
    return errorText
}
